import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ConditionIcon = function ConditionIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ConditionIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7.242 1.807A.8.8 0 0 1 8.067 1a.8.8 0 0 1 .793.807l-.003.37a282 282 0 0 0-.006 1.6v.036c0 .485.002.96.009 1.305.014.757.069 1.268.201 1.76.133.497.356 1.015.75 1.775.592 1.139 1.72 2.16 2.77 2.923.253.184.497.35.721.494V10.69a.8.8 0 1 1 1.6 0v3.333a.8.8 0 0 1-.8.8h-3a.8.8 0 0 1 0-1.6h1.04q-.241-.164-.502-.351c-1.111-.808-2.483-2.008-3.248-3.48a20 20 0 0 1-.341-.685q-.153.325-.341.685c-.765 1.472-2.137 2.672-3.249 3.48a18 18 0 0 1-.502.351h1.04a.8.8 0 1 1 0 1.6H2a.8.8 0 0 1-.8-.8V10.69a.8.8 0 1 1 1.6 0v1.381c.225-.144.469-.31.722-.494 1.05-.762 2.178-1.784 2.769-2.923.395-.76.617-1.278.75-1.775.133-.492.188-1.003.202-1.76.007-.344.009-.82.009-1.305v-.036a208 208 0 0 0-.006-1.6z",
      clipRule: "evenodd"
    })
  }));
};

export { ConditionIcon };
